import React from 'react';

const SvgCourseLevel = props => (
  <svg viewBox="0 0 39 38.8" id="course-path">
    <path
      className="azst0"
      d="M25.3 1.7L36.6 37H2.4L13.7 1.7h11.6m1-1.3H12.7L.5 38.4h38.1L26.3.4z"
    ></path>
    <path
      className="azst0"
      d="M39 38.8H0L12.4 0h14.2L39 38.8zm-38-.7h37.1L26.1.7H13L1 38.1zm36.2-.7H1.9l11.6-36h12.2l11.5 36zm-34.4-.7h33.4L25.1 2.1H14L2.8 36.7z"
    ></path>
    <path className="azst0" d="M18.8 23.8h1.4v11.6h-1.4z"></path>
    <path
      className="azst0"
      d="M20.6 35.8h-2.1V23.4h2.1v12.4zm-1.4-.7h.7v-11h-.7v11z"
    ></path>
    <g>
      <path className="azst0" d="M18.8 10h1.4v8.6h-1.4z"></path>
      <path
        className="azst0"
        d="M20.6 18.9h-2.1V9.6h2.1v9.3zm-1.4-.7h.7v-7.9h-.7v7.9z"
      ></path>
    </g>
    <g>
      <path className="azst0" d="M18.8 3.3h1.4v4.3h-1.4z"></path>
      <path
        className="azst0"
        d="M20.6 7.9h-2.1v-5h2.1v5zm-1.4-.7h.7V3.6h-.7v3.6z"
      ></path>
    </g>
  </svg>
);

export default SvgCourseLevel;
